import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['A long list of exercises with no way to choose between them', 'No words for how to offer it — so it sounds scripted or forced', 'One intensity: too much for some clients, too little for others', 'Nothing on closing, so the discovery leaves with the client', 'No notes on trauma, dissociation or crisis'];
const withIt = ['Organized by the figure you notice, not by alphabet', 'An exact offer line that leaves room for “no”', 'Gentle, moderate and intense versions of every card', 'Assimilate questions on every card', 'A safety flag on every card, plus a safety page per volume'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-cream" data-id="element-365" data-mp="2d7r4v4373fc5">
      <div className="mx-auto max-w-4xl px-5 py-16 sm:py-20" data-id="element-366" data-mp="30ymz07v4immk">
        <div className="text-center" data-id="element-367" data-mp="30waafbuv1e0j">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-terra-deep" data-id="element-368" data-mp="35pmz1lzjhkta">
            Why this isn’t another technique list
          </p>
          <h2 id="vs-heading" className="chalk-underline mt-3 font-display text-[28px] text-sage sm:text-5xl" data-id="element-369" data-mp="1tfmrgz45k987">
            A list of techniques vs <em data-id="element-370" data-mp="235y4rc9q7urr">a map you can use</em>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-371" data-mp="1yeg4kqfj1y7u">
            There are books and lists of Gestalt techniques. Knowing that
            experiments exist was never the hard part — choosing one in the
            moment, grading it and offering it so it doesn’t feel forced is.
            That’s what this library is built around.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-2xl border border-sand-dark shadow-card" data-id="element-372" data-mp="2m1xwqn2peybc">
          <div className="bg-sand px-3.5 py-4 sm:p-6" data-id="element-373" data-mp="rpzp2pk1mahk">
            <span className="font-display text-xl leading-none text-ink-soft sm:text-3xl" data-id="element-374" data-mp="rqsqrc45a9su">
              Technique list
            </span>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-widest text-ink-muted" data-id="element-375" data-mp="mt97fxslb6u1">
              Books, PDFs, exercise lists
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-376" data-mp="2rt1y0rzp3y83">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-ink-soft sm:text-sm" data-id="element-377" data-mp="2vssvfejq9cll">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-terra/20" data-id="element-378" data-mp="35sa3g2mgc2kq">
                    <XIcon className="h-2.5 w-2.5 text-terra-deep" aria-hidden="true" data-id="element-379" data-mp="3aq34yict88eo" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-sage px-3.5 py-4 text-cream sm:p-6" data-id="element-380" data-mp="3jidhi6b6gpz3">
            <span className="font-display text-xl leading-none sm:text-3xl" data-id="element-381" data-mp="3oirs9w45ye0t">
              Session Ready
            </span>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-widest text-ochre-soft" data-id="element-382" data-mp="3tgt6a2mqfn5f">
              The Figure-to-Experiment Map
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-383" data-mp="7dsous2c1y3m">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-medium leading-snug sm:text-sm" data-id="element-384" data-mp="2j58xhleac0n">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-ochre/30" data-id="element-385" data-mp="3pn366uv7xoxu">
                    <CheckIcon className="h-2.5 w-2.5 text-ochre-soft" aria-hidden="true" data-id="element-386" data-mp="q8r5dxadud4y" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}